import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Verify from './pages/Verify.jsx';
import MailBack from './pages/MailBack.jsx';
import BinFinder from './pages/BinFinder.jsx';
import Education from './pages/Education.jsx';
import MyImpact from './pages/MyImpact.jsx';
import Login from './pages/Login.jsx';
import Signup from './pages/Signup.jsx';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/bin-finder" element={<BinFinder />} />
        <Route path="/learn" element={<Education />} />
        <Route path="/my-impact" element={<MyImpact />} />
        <Route path="/mail-back" element={<MailBack />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </Layout>
  );
}

export default App;
